export default "__VITE_ASSET__CGPw$ujp__"